<template>
    <div class="fill-height guide-creation">
        <h2 class="text-uppercase px-0">{{title}}</h2>
        <p>{{text}}</p>
    </div>
</template>

<style lang="scss">
    .guide-creation{
        padding: 0 1rem;
        h2, p{
            color: $grey;
        }
        p{
            font-size: 0.8rem;
            @include bigScreen{
                font-size: 1rem;
            }
        }
    }
</style>

<script>
export default {
  name: 'GuideCreation',
  props: ['title', 'text'],
  data: () => ({})
}
</script>